"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionCreateCommand = instanceOfCompetitionCreateCommand;
exports.CompetitionCreateCommandFromJSON = CompetitionCreateCommandFromJSON;
exports.CompetitionCreateCommandFromJSONTyped = CompetitionCreateCommandFromJSONTyped;
exports.CompetitionCreateCommandToJSON = CompetitionCreateCommandToJSON;
exports.CompetitionCreateCommandToJSONTyped = CompetitionCreateCommandToJSONTyped;
var CompetitionSectionCommand_1 = require("./CompetitionSectionCommand");
var CompetitionState_1 = require("./CompetitionState");
var CompetitionSettingsCommand_1 = require("./CompetitionSettingsCommand");
var ListingMode_1 = require("./ListingMode");
/**
 * Check if a given object implements the CompetitionCreateCommand interface.
 */
function instanceOfCompetitionCreateCommand(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('game' in value) || value['game'] === undefined)
        return false;
    return true;
}
function CompetitionCreateCommandFromJSON(json) {
    return CompetitionCreateCommandFromJSONTyped(json, false);
}
function CompetitionCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'game': json['game'],
        'image': json['image'] == null ? undefined : json['image'],
        'disambiguatingDescription': json['disambiguatingDescription'] == null ? undefined : json['disambiguatingDescription'],
        'state': json['state'] == null ? undefined : (0, CompetitionState_1.CompetitionStateFromJSON)(json['state']),
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'restrictToCommunities': json['restrictToCommunities'] == null ? undefined : json['restrictToCommunities'],
        'dateTouched': json['dateTouched'] == null ? undefined : (new Date(json['dateTouched'])),
        'listingMode': json['listingMode'] == null ? undefined : (0, ListingMode_1.ListingModeFromJSON)(json['listingMode']),
        'settings': json['settings'] == null ? undefined : (0, CompetitionSettingsCommand_1.CompetitionSettingsCommandFromJSON)(json['settings']),
        'section': json['section'] == null ? undefined : (0, CompetitionSectionCommand_1.CompetitionSectionCommandFromJSON)(json['section']),
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
    };
}
function CompetitionCreateCommandToJSON(json) {
    return CompetitionCreateCommandToJSONTyped(json, false);
}
function CompetitionCreateCommandToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'game': value['game'],
        'image': value['image'],
        'disambiguatingDescription': value['disambiguatingDescription'],
        'state': (0, CompetitionState_1.CompetitionStateToJSON)(value['state']),
        'ordinal': value['ordinal'],
        'restrictToCommunities': value['restrictToCommunities'],
        'dateTouched': value['dateTouched'] == null ? undefined : ((value['dateTouched']).toISOString()),
        'listingMode': (0, ListingMode_1.ListingModeToJSON)(value['listingMode']),
        'settings': (0, CompetitionSettingsCommand_1.CompetitionSettingsCommandToJSON)(value['settings']),
        'section': (0, CompetitionSectionCommand_1.CompetitionSectionCommandToJSON)(value['section']),
        'platforms': value['platforms'],
    };
}
